<!--suppress JSNonASCIINames -->
<template>
  <print v-if="isPrint" :board="board" :form="form" :inspection-title="inspectionTitle"/>
  <div v-else>
    <!--상단 현재 상태를 표시한다-->
    <div class="overflow-x-auto">
      <status-step930 :status="statusNumber" :width="'100%'"/>
    </div>

    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" title="허가 신청자"/>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>허가신청기간</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.허가신청기간 }}</p>
          <date-selector v-else class="w-full" v-model="form.작업정보.허가신청기간" />
        </div>
        <div>
          <div>작업시간</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업시간.시작 }} ~ {{ form.작업정보.작업시간.종료 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.작업정보.작업시간.시작" :readonly="board.readonly" />
            <p class="px-2">~</p>
            <time-selector v-model="form.작업정보.작업시간.종료" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div class="flex" style="width: 100%; align-items: center;">
            <div style="min-width: 100px;">
              <PrintCheckbox v-if="isPrint" :value="form.작업정보.연장신청" color/>
              <vs-checkbox v-else v-model="form.작업정보.연장신청" :readonly="board.readonly">연장신청</vs-checkbox>
            </div>
            <p>※ 최초허가기간(최대 8시간) 종료후 최대 4시간까지 연장허가 가능</p>
          </div>
        </div>

        <div>
          <div>허가승인일시</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.허가승인일시 }}</p>
          <date-selector v-else class="w-full" v-model="form.작업정보.허가승인일시" />
        </div>
        <div>
          <div>시각</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.허가시각 }}</p>
          <time-selector v-else class="w-full" v-model="form.작업정보.허가시각" />
        </div>
        <div>
          <div v-if="!isPrint" class="flex justify-end xl:justify-start" style="width: 100%; align-items: center;">
            <vs-button color="#28C76F" text-color="white" type="filled" @click="handleConfirm">승인</vs-button>
            <vs-button class="ml-2" color="#EA5455" text-color="white" type="filled" @click="handleReject">반려</vs-button>
          </div>
        </div>

        <div>
          <div>연장신청기간</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.연장신청기간 }}</p>
          <date-selector v-else class="w-full" v-model="form.작업정보.연장신청기간" />
        </div>
        <div>
          <div>연장시간</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.연장시간.시작 }} ~ {{ form.작업정보.연장시간.종료 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.작업정보.연장시간.시작" :readonly="board.readonly" />
            <p class="px-2">~</p>
            <time-selector v-model="form.작업정보.연장시간.종료" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div v-if="!isPrint" class="flex justify-end xl:justify-start" style="width: 100%; align-items: center;">
            <vs-button color="#7E72F2" text-color="white" type="filled" @click="handleProposal">신청</vs-button>
          </div>
        </div>

        <!--작업 시작-->
        <div>
          <div>작업시작일시</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업시작날짜 }}</p>
          <date-selector v-else class="w-full" v-model="form.작업정보.작업시작날짜" />
        </div>
        <div>
          <div>시각</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업시작시간 }}</p>
          <time-selector v-else class="w-full" v-model="form.작업정보.작업시작시간" />
        </div>
        <div>
          <div v-if="!isPrint" class="flex justify-end xl:justify-start" style="width: 100%; align-items: center;">
            <vs-button color="#7E72F2" text-color="white" type="filled" @click.stop.prevent="handleWorkStart">작업시작</vs-button>
          </div>
        </div>

        <!--작업 완료-->
        <div>
          <div>작업완료일시</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업완료날짜 }}</p>
          <date-selector v-else class="w-full" v-model="form.작업정보.작업완료날짜" />
        </div>
        <div>
          <div>시각</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업완료시간 }}</p>
          <time-selector v-else class="w-full" v-model="form.작업정보.작업완료시간" />
        </div>
        <div>
          <div v-if="!isPrint" class="flex justify-end xl:justify-start" style="width: 100%; align-items: center;">
            <vs-button color="#7E72F2" text-color="white" type="filled" @click="handleWorkCompletion">작업종료</vs-button>
          </div>
        </div>

        <div class="writeGridCol2">
          <div>업체명</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.업체명 }}</p>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            :fieldId="form.stdInfo.field_id"
            v-model="form.작업정보.업체번호"
            placeholder="선택"
            @select="targetCompany">
          </CompanySelector>
        </div>

        <div class="writeGridCol2">
          <div>작업허가명</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업허가명 }}</p>
          <ml-input v-else class="w-full" v-model="form.작업정보.작업허가명" />
        </div>

        <div class="writeGridCol2">
          <div>허가번호</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.허가번호 }}</p>
          <ml-input v-else class="w-full" v-model="form.작업정보.허가번호" />
        </div>

        <!--작업 장소-->
        <div></div>
        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업구역.label }}</p>
          <vs-select v-else v-model="form.stdInfo.region_id" @input="handleChangeRegion">
            <vs-select-item  v-for="(data, index) in form.regionOptions" :key="index" :text="data.label" :value="data.value" />
          </vs-select>
        </div>
        <div>
          <template v-if="form.zoneOptions.length > 0">
            <div>작업위치</div>
            <p v-if="isPrint" class="print-input">{{ form.작업정보.작업존.label }}</p>
            <vs-select v-else v-model="form.stdInfo.zone_id" @input="handleChangeZone">
              <vs-select-item  v-for="(data, index) in form.zoneOptions" :key="index" :text="data.label" :value="data.value" />
            </vs-select>
          </template>
        </div>
        <div></div>

        <div class="writeGridCol2">
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.작업내용 }}</p>
          <ml-input v-else class="w-full" v-model="form.작업정보.작업내용" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <div class="flex flex-wrap justify-between items-center">
        <h5 class="mb-4 "><i class="dot"></i> 안전관계자(승인권자)</h5>
        <div class="mb-4 flex ml-auto">
          <vs-button class="mr-2" color="secondary" @click="addSafetyManager">공사업체 인원 추가</vs-button>
          <vs-button color="secondary" type="border" @click="removeSafetyManager">마지막 행삭제</vs-button>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>동국제강</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.동국제강.이름 }}</p>
          <ml-input v-else class="w-full" v-model="form.안전관계자.동국제강.이름" />
        </div>
        <div>
          <div>전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.동국제강.전화번호 }}</p>
          <ml-input v-else class="w-full" v-model="form.안전관계자.동국제강.전화번호" />
        </div>
      </div>

      <div class="writeGridContainer" :class="{'border-top': isMobile}" style="margin-bottom: 0.625rem; padding-top:0.625rem;" v-for="(contractor, idx) in form.안전관계자.공사업체" :key="idx">
        <div>
          <div>공사업체</div>
          <p v-if="isPrint" class="print-input">{{ contractor.이름 }}</p>
          <ml-input v-else class="w-full" v-model="contractor.이름" />
        </div>
        <div>
          <div>전화번호</div>
          <p v-if="isPrint" class="print-input">{{ contractor.전화번호 }}</p>
          <ml-input v-else class="w-full" v-model="contractor.전화번호" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>확인자(안전환경팀, 필요시)</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.확인자유무 }}</p>
          <div v-else class="w-full flex-1 flex gap-4">
            <vs-radio v-model="form.안전관계자.확인자유무" :disabled="board.readonly" vs-name="확인자유무" vs-value="y">Y</vs-radio>
            <vs-radio v-model="form.안전관계자.확인자유무" :disabled="board.readonly" vs-name="확인자유무" vs-value="n">N</vs-radio>
          </div>
        </div>
        <div>
          <div>확인자</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.확인자 }}</p>
          <ml-input v-else class="w-full" v-model="form.안전관계자.확인자" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.안전관계자.확인자서명.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.안전관계자.확인자서명.sign" :src="form.안전관계자.확인자서명.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 작업유형 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업유형</h5>
      <div class="grid xl:grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div v-for="_title in inspectionTitle" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
            {{ _title }}
          </span>
          </div>
          <div v-else>
          <span class="flex ">
            <vs-checkbox :readonly="board.readonly" v-model="form.inspectChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
          </span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-for="(_title, _title_i) in inspectionTitle"
      :key="`inspect_${_title}`"
      v-show="form.inspectChecked.includes(_title)"
    >
      <table-inspect-merge
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :title="_title"
        :table-header-title="'점검사항'"
        :table-header-check="[{ text: '신청자' }, { text: '허가자' }, { text: '연장허가' }]"
        :table-header-note="[]"
        :contentBefore="'•'"
        v-model="form[`inspectList_${_title_i + 1}`]"
        class="mt-5"
      >
        <template #customContent="{ trData }">
          <!-- 일반작업 -->
          <div v-if="_title_i === 0">
            <div class="flex" style="align-items: center;">
              <p style="color: #4839EB;">위치:</p>
              <p v-if="isPrint">{{ trData.위치 }}</p>
              <ml-input v-else v-model="trData.위치" class="mx-2" style="width: 350px;"/>
            </div>
          </div>

          <!-- 화기작업 -->
          <div v-else-if="_title_i === 1">
            <div class="flex" style="align-items: center;">
              <p style="color: #4839EB;">성명:</p>
              <p v-if="isPrint">{{ trData.성명 }}</p>
              <ml-input v-else v-model="trData.성명" class="mx-2" />
            </div>
          </div>

          <!-- 중장비 관련 작업 -->
          <div v-else-if="_title_i === 3">
            <div class="flex" style="align-items: center;">
              <p v-if="isPrint">{{ trData.투입장비 }}</p>
              <ml-input v-else v-model="trData.투입장비" class="mx-2" style="width: 310px;"/>
            </div>
          </div>

          <!-- 정전(전기차단)작업 -->
          <div v-else-if="_title_i === 5">
            <div v-if="trData.customType === '1'" class="flex" style="align-items: center;">
              <p style="color: #4839EB;">차단기 번호:</p>
              <p v-if="isPrint">{{ trData.차단기번호 }}</p>
              <ml-input v-else v-model="trData.차단기번호" class="mx-2" />
            </div>
            <div v-else-if="trData.customType === '2'" class="flex" style="align-items: center;">
              <p style="color: #4839EB;">차단자:</p>
              <p v-if="isPrint">{{ trData.차단자 }}</p>
              <ml-input v-else v-model="trData.차단자" class="mx-2" />
              <p style="color: #4839EB;">차단시간:</p>
              <p v-if="isPrint">{{ trData.차단시간 }}</p>
              <time-selector v-else v-model="trData.차단시간" class="mx-2" />
            </div>
            <div v-else-if="trData.customType === '3'" class="flex" style="align-items: center;">
              <p style="color: #4839EB;">복구자:</p>
              <p v-if="isPrint">{{ trData.복구자 }}</p>
              <ml-input v-else v-model="trData.복구자" class="mx-2" />
              <p style="color: #4839EB;">복구시간:</p>
              <p v-if="isPrint">{{ trData.복구시간 }}</p>
              <time-selector v-else v-model="trData.복구시간" class="mx-2" />
            </div>
          </div>

          <!-- 방사선 관련 작업 -->
          <div v-else-if="_title_i === 7">
            <div class="flex" style="align-items: center;">
              <p v-if="isPrint">{{ trData.작업감시자 }}</p>
              <ml-input v-else v-model="trData.작업감시자" class="mx-2" style="width: 200px;"/>
            </div>
          </div>
        </template>
      </table-inspect-merge>

      <!-- 화기작업 -->
      <table-custom
        v-if="_title === '화기작업'"
        :board="board"
        :is-print="isPrint"
        title="가스농도 측정결과(화기작업)"
        :tableData="[
        { id: '물질명', title: '물질명', type: 'text', placeholder: '' },
        { id: '결과', title: '결과', type: 'text', placeholder: '', afterText: 'LEL%' },
        { id: '측정시간', title: '측정시간', type: 'time', },
        { id: '측정자', title: '측정자', type: 'text', placeholder: '' },
        { id: '비고', title: '비고', type: 'text', placeholder: '' },
      ]"
        :mobile="['물질명', '결과']"
        v-model="form.화기작업"
        class="mt-28px"
      />

      <!-- 밀폐(제한)공간 작업  -->
      <table-custom
        v-if="_title === '밀폐공간 작업'"
        :board="board"
        :is-print="isPrint"
        title="가스농도 측정결과(밀폐공간)"
        :tableData="[
        { id: '물질명', title: '물질명 / 기준 / 결과', type: 'customType', style: { padding: 0 } },
        { id: '측정시간', title: '측정시간', type: 'time', width: '200px' },
        { id: '측정자', title: '측정자', type: 'text', placeholder: '', width: '200px' },
        { id: '비고', title: '비고', type: 'text', placeholder: '', width: '200px' },
      ]"
        :mobile="['물질명', '결과']"
        v-model="form.밀폐작업"
        class="mt-28px"
      >
        <template #customType="{ trData, id, index, input, noteIndex }">
          <div v-if="trData" class="grid w-full" style="grid-template-columns: 1fr 1fr 1fr 1fr;">
            <!-- 산소 -->
            <div style="border-right: 1px solid #cdcdcd; align-content: center; justify-items: start; min-height: 50px; padding: 8px;">
              <span>산소(O2) : 18%~23.5%</span>
              <div class="flex">
                <p v-if="isPrint" class="print-input">{{ form.밀폐작업[index].산소 }}</p>
                <ml-input v-else v-model="form.밀폐작업[index].산소" class="w-full" />
                <span class="mx-2" style="align-content: center;">%</span>
              </div>
            </div>
            <!-- 탄산가스 -->
            <div style="border-right: 1px solid #cdcdcd; align-content: center; justify-items: start; min-height: 50px; padding: 8px;">
              <span>탄산가스(CO2) : 1.5% ↓</span>
              <div class="flex">
                <p v-if="isPrint" class="print-input">{{ form.밀폐작업[index].탄산가스 }}</p>
                <ml-input v-else v-model="form.밀폐작업[index].탄산가스" class="w-full" />
                <span class="mx-2" style="align-content: center;">%</span>
              </div>
            </div>
            <!-- 일산화탄소 -->
            <div style="border-right: 1px solid #cdcdcd; align-content: center; justify-items: start; min-height: 50px; padding: 8px;">
              <span>일산화탄소(CO) :  30ppm ↓</span>
              <div class="flex">
                <p v-if="isPrint" class="print-input">{{ form.밀폐작업[index].일산화탄소 }}</p>
                <ml-input v-else v-model="form.밀폐작업[index].일산화탄소" class="w-full" />
                <span class="mx-2" style="align-content: center;">ppm </span>
              </div>
            </div>
            <!-- 황화수소 -->
            <div style="align-content: center; justify-items: start; min-height: 50px; padding: 8px;">
              <span>황화수소(H2S) : 10ppm ↓</span>
              <div class="flex">
                <p v-if="isPrint" class="print-input">{{ form.밀폐작업[index].황화수소 }}</p>
                <ml-input v-else v-model="form.밀폐작업[index].황화수소" class="w-full" />
                <span class="mx-2" style="align-content: center;">ppm </span>
              </div>
            </div>
          </div>
        </template>
      </table-custom>

    </div>

    <!--작업자 내역-->
    <worker-list930 v-model="form.작업자내역" :qr-list="qrList"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import * as inspectData from "./inspectData";
import StatusStep930 from "@/views/boards/single-page/930/StatusStep930.vue";
import WorkerList930 from "@/views/boards/single-page/930/WorkerList930.vue";
import Print from "./Print.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    Print,
    WorkerList930,
    StatusStep930,
    SignField,
    CompanySelector,
    PrintCheckbox,
    TimeSelector,
    TableCustom,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    post: Object,   // 게시글 전체 정보
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    qrList() {
      return this.post.qr_reads;
    },
    /**
     * 현재 문서의 상태를 반환한다.
     * 1: 등록
     * 2: 입문 (작업자 중에, 입문시간이 1개라도 입력되어 있으면 입문으로 간주)
     * 3: 작업중 (작업시작날짜 값이 있으면 작업중으로 간주)
     * 4: 작업완료 (작업완료날짜 값이 있으면 작업완료로 간주)
     * 5: 출문 (모든 작업자가 출문시간을 입력하면 출문으로 간주)
     */
    statusNumber() {
      const workers = this.form.작업자내역;
      const workStart = this.form.작업정보.작업시작날짜;
      const workEnd = this.form.작업정보.작업완료날짜;

      if (workers.length > 0 && workers.every((worker) => worker.출문시간)) return 5;

      if (workEnd) return 4;
      if (workStart) return 3;
      if (workers.some((worker) => worker.입문시간)) return 2;
      return 1;
    },
    isMobile() {
      return this.$viewport.isMobile;
    },
  },
  data() {
    return {
      inspectionTitle: [
        "일반작업", "화기작업", "고소작업", "중장비 작업",
        "밀폐공간 작업", "정전(전기차단)작업", "굴착작업", "방사선 관련 작업"
      ],

      form: {
        stdInfo: {},

        상태: "",
        구분: "돌발보수",
        작업정보: {
          허가신청기간: "",
          작업시간: { 시작: "", 종료: "" },
          연장신청: false,
          허가승인일시: "",
          허가시각: "",
          연장신청기간: "",
          연장시간: { 시작: "", 종료: "" },
          작업시작날짜: "",
          작업시작시간: "",
          작업완료날짜: "",
          작업완료시간: "",
          업체명: "",
          업체번호: "",
          작업허가명: "",
          허가번호: "",
          작업구역: {},
          작업존: {},

          승인상태: "",
          연장상태: "",
          작업종료상태: "",
        },
        안전관계자: {
          동국제강: {
            이름: "",
            전화번호: "",
          },
          공사업체: [{ 이름: "", 전화번호: "" }],
          확인자유무: "",
          확인자: "",
          확인자서명: { sign: "" },
        },


        inspectChecked: [],
        inspectList_1: inspectData.inspectTable_1,
        inspectList_2: inspectData.inspectTable_2,
        inspectList_3: inspectData.inspectTable_3,
        inspectList_4: inspectData.inspectTable_4,
        inspectList_5: inspectData.inspectTable_5,
        inspectList_6: inspectData.inspectTable_6,
        inspectList_7: inspectData.inspectTable_7,
        inspectList_8: inspectData.inspectTable_8,

        화기작업: [],
        밀폐작업: [],

        작업자내역: [],


        fileList: [],

        regionOptions: [],
        zoneOptions: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.상태 = this.statusNumber;

        this.$emit("input", value);
      },
    },
  },
  created() {
    this.loadRegionList();
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.isPrint = true;
  //   }, 3000);
  // },
  methods: {
    handleConfirm() {
      this.form.작업정보.승인상태 = "승인";
    },
    handleReject() {
      this.form.작업정보.승인상태 = "반려";
    },
    handleProposal() {
      this.form.작업정보.연장상태 = "신청";
    },
    /**
     * 작업 시작 시각을 현재 로컬 시간으로 입력한다
     */
    handleWorkStart() {
      const now = new Date();
      this.$set(this.form.작업정보, "작업시작날짜", now.toDateString());
      this.$set(this.form.작업정보, "작업시작시간", now.toTimeString().split(" ")[0]);
    },
    handleWorkCompletion() {
      const now = new Date();
      this.$set(this.form.작업정보, "작업완료날짜", now.toDateString());
      this.$set(this.form.작업정보, "작업완료시간", now.toTimeString().split(" ")[0]);
    },

    targetCompany(data) {
      this.form.작업정보.업체명 = data.companyName
    },

    addSafetyManager() {
      this.form.안전관계자.공사업체.push({ 이름: "", 전화번호: "" });
    },
    removeSafetyManager() {
      if (this.form.안전관계자.공사업체.length < 2) return;

      this.form.안전관계자.공사업체.pop();
    },

    async loadRegionList() {
      const api = '/api/v1/region';
      HttpRequest.get(api)
        .then(response => {
          const data = response.data;
          this.form.regionOptions = data.map((region) => {
            return {
              value: region.id,
              label: region.name,
            };
          });
        }).catch(err => {
          console.log(err);
        });
    },
    async loadZoneList(regionId) {
      if (!regionId) {
        return;
      }
      this.form.stdInfo.zone_id = 0;
      this.form.작업정보.작업존 = {};
      this.form.zoneOptions = [];
      const api = `/api/v1/region/${regionId}`;
      HttpRequest.get(api, {params: {regionId}})
        .then(response => {
          if (response && response.length > 0) {
            const data = response[0];
            this.form.zoneOptions = (data.zones || []).map((zone) => {
              return {
                value: zone.id,
                label: zone.name,
              };
            });
          }
        }).catch(err => { console.log("err", err) })
    },
    handleChangeRegion(selectedRegionId) {
      if (this.form.작업정보.작업구역 && this.form.작업정보.작업구역.value && this.form.작업정보.작업구역.value === selectedRegionId) {
        return;
      }
      const selectedRegion = this.form.regionOptions.find((region) => region.value === selectedRegionId);
      this.$set(this.form.작업정보, "작업구역", selectedRegion);
      this.$set(this.form.stdInfo, "region_name", selectedRegion.label);
      this.loadZoneList(selectedRegionId);
    },
    handleChangeZone(selectedZoneId) {
      const selectedZoneOption = this.form.zoneOptions.find((zone) => zone.value === selectedZoneId);
      this.$set(this.form.작업정보, "작업존", selectedZoneOption);
      this.$set(this.form.stdInfo, "zone_name", selectedZoneOption.label);
    },
  },

};
</script>

<style scoped lang="scss"></style>
